import { render, staticRenderFns } from "./AddFNAC.vue?vue&type=template&id=0bdb9b1a&scoped=true&"
import script from "./AddFNAC.vue?vue&type=script&lang=js&"
export * from "./AddFNAC.vue?vue&type=script&lang=js&"
import style0 from "./AddFNAC.vue?vue&type=style&index=0&id=0bdb9b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb9b1a",
  null
  
)

export default component.exports